import { render } from "./StatusInfoModal.vue?vue&type=template&id=3ab48b62"
import script from "./StatusInfoModal.vue?vue&type=script&lang=js"
export * from "./StatusInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__